<template>
  <div class="smartcard">
    <b-button
      variant="primary"
      block
      @click="scanReaderData"
      style="line-height: 0.7"
      v-b-tooltip.hover
      title="สแกนบัตรประชาชนด้วย DentCloud Hardware Bridge (DCB)"
    >
      <span class="small-text">สแกน DCB</span>
    </b-button>
    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import bridgeService from "@/services/HardwareBridgeService";

const LEGACY_URL = "ws://localhost:8088";
const LEGACY_TIMEOUT = 2000;

export default {
  name: "SmartCard",
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      useBridge: false,
      legacySocket: null,
      bridgeUnsub: null,
      readerMessage: null,
      readerData: null
    };
  },
  beforeDestroy() {
    this.cleanup();
  },
  methods: {
    async scanReaderData() {
      this.isLoading = true;

      // Try Hardware Bridge first
      try {
        await bridgeService.connect();
        this.useBridge = true;
        this.bridgeUnsub = bridgeService.send(
          { type: "card-reader", action: "read" },
          response => this.handleBridgeResponse(response)
        );
        return;
      } catch {
        // Bridge unavailable, fall back to legacy
      }

      // Legacy fallback
      try {
        this.legacySocket = await this.connectLegacy();
      } catch {
        this.isLoading = false;
        this.$emit(
          "showDialogToast",
          "warning",
          "ไม่สามารถเชื่อมต่อโปรแกรมอ่านบัตรได้ กรุณาเปิดโปรแกรม Hardware Bridge"
        );
        return;
      }

      this.legacySocket.onmessage = res => {
        let data = JSON.parse(res.data);
        this.handleCardData(data);
      };

      this.legacySocket.onerror = () => {
        this.$emit("showDialogToast", "warning", "WebSocket error");
        this.isLoading = false;
      };

      this.legacySocket.onclose = () => {
        // Legacy server may close after sending data — that's OK
        this.legacySocket = null;
      };

      this.legacySocket.send("READ");
    },

    connectLegacy() {
      return new Promise((resolve, reject) => {
        const ws = new WebSocket(LEGACY_URL);
        const timeout = setTimeout(() => {
          ws.close();
          reject(new Error("Legacy card reader unavailable"));
        }, LEGACY_TIMEOUT);

        ws.onopen = () => {
          clearTimeout(timeout);
          resolve(ws);
        };

        ws.onerror = () => {
          clearTimeout(timeout);
          ws.close();
          reject(new Error("Legacy card reader unavailable"));
        };
      });
    },

    handleBridgeResponse(response) {
      // Unwrap Bridge format: { type: 'card-reader', data: { success, personal, ... } }
      const data = response.data || response;
      this.handleCardData(data);
    },

    handleCardData(data) {
      this.isLoading = false;
      if (!data.success) {
        this.$emit("showDialogToast", "warning", data.msgDetail);
        return;
      }
      this.readerData = Object.assign(data.personal);
      this.$emit("getReaderData", this.readerData);
    },

    cleanup() {
      this.isLoading = false;
      if (this.bridgeUnsub) {
        this.bridgeUnsub();
        this.bridgeUnsub = null;
      }
      if (this.legacySocket) {
        this.legacySocket.close();
        this.legacySocket = null;
      }
    }
  }
};
</script>
